import { BehaviorSubject } from "rxjs";
import { IChecklistFormControlOptions } from "../checklist-form-control/i-checklist.form-control.options";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSChecklistOptions implements _SSControlOptionsBase<'checklist'>  {

    readonly listItemsSubject = new BehaviorSubject<{ value: any, text: string }[]>([])
    readonly canUserDisableSubject = new BehaviorSubject<boolean>(true)

    constructor(
        private _initialOptions?: IChecklistFormControlOptions
    ) {

        this._initOptions();
    }

    private _initOptions() {
        FormControlOptionsUtils.initMappedObject<'checklist'>(this, this._initialOptions);

    }

    dispose() {

    }
}